import axios from "axios";
import { IP } from "../utils/Host";

export function addNewProcess(row, procesyElementowTemporary, setProcesyElementowTemporary, procesList) {
  const procesyElementowEditTemporary = procesyElementowTemporary.slice();

  // Szukamy konkretnego procesu: Uszlachetnianie (id: 14)
  const defaultProc = procesList.find((x) => x.id == 14) || procesList[0];

  if (!defaultProc) {
    console.warn("Nie znaleziono domyślnego procesu w procesList");
    return;
  }

  const maxId = procesyElementowTemporary.length > 0
    ? Math.max(...procesyElementowTemporary.map((f) => Number(f.id) || 0))
    : 0;

  procesyElementowEditTemporary.push({
    ...defaultProc,        // Przepisuje m.in. nazwa_id: 2 oraz dane techniczne
    id: maxId + 1,
    zamowienie_id: row.zamowienie_id,
    produkt_id: row.produkt_id,
    element_id: row.id,
    ilosc_uzytkow: 2,
    proces_id: defaultProc.id,       // 14
    nazwa_id: defaultProc.nazwa_id,   // 2
    front_ilosc: 1,
    back_ilosc: 0,
    front_kolor: "",
    back_kolor: "",
    info: "",
    indeks: newIndex(row, procesyElementowTemporary),
    insert: true
  });

  procesyElementowEditTemporary.sort((a, b) => a.indeks - b.indeks);
  setProcesyElementowTemporary(procesyElementowEditTemporary);
}

const newIndex = (row, procesyElementowTemporary) => {
  let index;

  if (procesyElementowTemporary.filter(x => x.element_id == row.id && x.delete != true).length == 0) {
    index = 1;
  } else {
    index = Math.max(...procesyElementowTemporary.filter(x => x.element_id == row.id && x.delete != true).map((f) => f.indeks)) + 1;
  }

  return index;
};